import SlideObject3DModel from './SlideObject3DModel';

export default SlideObject3DModel;
